import { BVScheduledTransport } from '@/modules/common/model';

export enum TripStatus {
  None = 'none',
  Found = 'found', // selected from listing
  Listed = 'listed', // confirmed via modal search
  Forced = 'forced', // manual entry, not found in API
  Unknown = 'unknown', // no flight/train number
}

export interface Trip {
  results: Array<any>;
  isFetchingInformations: boolean;
  status: TripStatus;
  informations?: string | number | any;
  number?: string;
}

export type TripDetail = BVScheduledTransport | Record<string, never>;
